export enum UploadTaskStateEnum {
  PENDING_PREPROCESS = 'PENDING_PREPROCESS',
  PENDING_UPLOAD = 'PENDING_UPLOAD',
  UPLOADED = 'UPLOADED',
  FAILED = 'FAILED',
}

export function isPendingUploadTaskState(state: UploadTaskStateEnum): boolean {
  return state === UploadTaskStateEnum.PENDING_PREPROCESS || state === UploadTaskStateEnum.PENDING_UPLOAD;
}
